@if (!isNew) {
	<app-record-header
		[recordData]="recordData()"
		[moduleName]="'vehicle-insurances|title'"
		[module]="module"
		[headerData]="headerData"
		[isNew]="isNew"
		[isSaving]="isSaving"
		[isEditMode]="isEditMode"
		(onEdit)="onEditClicked()"
		(onSave)="onSaveClicked()"
		(onCancel)="onCancelClicked()"
		(onTitleClick)="onTitleClicked()"
		[isSaveButtonActive]="isSaveButtonActive"
		[isStacked]="isStacked()"
		[savedWhileEditing]="savedWhileEditing()">
		<div class="record-menu">
			<app-vehicle-insurances-list-item-menu
				#recordListMenu
				[isEditMode]="isEditMode"
				[item]="recordData()" />
		</div>
	</app-record-header>
}

<ion-content [scrollY]="false" [scrollX]="false">
	<ion-nav #nav />
</ion-content>

<ng-template #tabsBody>
	@if (!isNew) {
		<app-record-tabs
			pane-body
			[selectedTab]="recordTab"
			[moduleEnum]="this.module"
			[id]="this.recordData().id"
			[isNew]="isNew"
			[recordTabs]="recordTabs"
			(viewDetails)="showMoreSections()">
			<ng-template [tabContent]="recordTabs.overview.value">
				<ng-container [ngTemplateOutlet]="overview"></ng-container>
			</ng-template>

			<ng-template [tabContent]="recordTabs.links.value">
				<app-module-selector
					[nav]="nav"
					[isNew]="isNew"
					[recordId]="recordData().id" />
			</ng-template>
			<ng-template [tabContent]="recordTabs.activity.value">
				<app-no-activity />
			</ng-template>
		</app-record-tabs>
	}
</ng-template>

<ng-template #overview>
	<app-vehicle-insurances-summary
		[isNew]="isNew"
		[recordData]="recordData()"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />

	@if (recordData().notes) {
		<app-comments-card [recordData]="recordData()" />
	}

	<app-annotations-section
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="true"
		(sectionChanged)="
			sectionDataChangedHandler($event); isNew ? null : saveSection()
		" />
</ng-template>

<ng-template #moreSections>
	@if (!isNew) {
		<app-more-details
			[nav]="nav"
			[isNew]="isNew"
			[footer]="recordFooter"
			[projectedSections]="recordSections()"
			[errors]="errorMessages | async"
			(onBack)="navToTabs()">
		</app-more-details>
	} @else {
		<app-stepper
			[overview]="overview"
			[isStacked]="isStacked()"
			[newSaveButton]="newSaveButton"
			[errors]="errorMessages | async"
			[title]="'vehicle-insurances|add-title'"
			[projectedSections]="recordSections()" />
	}
</ng-template>

<ng-template #newSaveButton>
	<button
		[disabled]="!isSaveButtonActive || isSaving"
		(click)="onSaveClicked()"
		color="primary"
		type="button"
		ultra-primary
		svgIcon="check"></button>
</ng-template>

<ng-template #recordFooter>
	<app-context-info [numberOfErrors]="(errorMessages | async)?.length">
		<ng-content select=".context-info-extras"></ng-content>
		<app-errors-box [errorMessages]="errorMessages | async" />
	</app-context-info>

	<ion-fab slot="fixed">
		<app-record-footer
			[isSaving]="isSaving"
			[isEditMode]="isEditMode"
			[isDeleted]="false"
			[isSaveButtonActive]="isSaveButtonActive"
			(onEdit)="onEditClicked()"
			(onSave)="onSaveClicked()"
			(onCancel)="onCancelClicked()" />
	</ion-fab>
</ng-template>

<ng-template
	[appSectionMetadata]="{
		title: 'vehicles|display-section|title',
	}">
	@if (
		features.vehicles &&
		recordData().recordCategory === recordCategories.VEHICLE &&
		originModule() !== modulesEnum.VEHICLES
	) {
		<ng-container [ngTemplateOutlet]="vehicle"></ng-container>
	}
	@if (isNew) {
		<ng-container [ngTemplateOutlet]="details"></ng-container>
	}
</ng-template>

@if (!isNew) {
	<ng-template
		[appSectionMetadata]="{
			title: 'vehicle-insurances|record|details-section|title',
		}">
		<ng-container [ngTemplateOutlet]="details"></ng-container>
	</ng-template>
}

<ng-template #details>
	<app-vehicle-insurances-details
		[isEditMode]="isEditMode"
		[isNew]="isNew"
		[recordData]="recordData()"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<ng-template #vehicle>
	<app-vehicle-section
		[recordData]="recordData()"
		[isNew]="isNew"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<ng-template
	[appSectionMetadata]="{
		title: 'shared|comments|title',
	}">
	<app-comments-section
		[isNew]="isNew"
		[recordData]="recordData()"
		[isEditMode]="isEditMode"
		(sectionChanged)="sectionDataChangedHandler($event)" />
</ng-template>

<!-- @if (isNew) {
	<ng-template
		[appSectionMetadata]="{
			title: 'shared|annotations',
		}">
		<app-annotations-section
			[isNew]="isNew"
			[recordData]="recordData()"
			[isEditMode]="isEditMode"
			(sectionChanged)="sectionDataChangedHandler($event)" />
	</ng-template>
} -->
